<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{ serviceMsg.serviceName }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ childName }}</el-breadcrumb-item>
    </el-breadcrumb>
    <ul class="nav clearfix">
      <li v-for="(item,index) in navList" :key="index" class="boxShadow" :class="{ 'select': selectIndex === item.type }" @click="selectNav(item.type)">
        <img :src="item.picUrl" alt="">
        <h3>{{ item.serviceName }}</h3>
      </li>
    </ul>
    <router-view></router-view>
    <!-- <MicroCommunity v-if="selectIndex === 15"></MicroCommunity>
    <Cooperation v-if="selectIndex === 8"></Cooperation> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import Cooperation from '@/pages/navigator/bbs/cooperation/Cooperation';
// import MicroCommunity from './microCommunity/MicroCommunity';

export default {
  data() {
    return {
      navList: [],
      selectIndex: 1,
      serviceMsg: {},
      childName: '',
    }
  },
  methods: {
    selectNav(active, item) {
      this.selectIndex = active;
      if (active === 8) {
        this.$router.push({ path: '/navigator/bbs/bbsNav/cooperation' });
      } else {
        this.$router.push({ path: '/navigator/bbs/bbsNav/microCommunity' });
      }
      const obj = this.serviceMsg.children.find((val) => {
        return val.type === active;
      });
      this.childName = obj.serviceName;
    },
    getNavList(flag) {  // 获取商务平台列表
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/list`, {
        parkId: this.currentParkId,
        parentId: this.serviceMsg.serviceId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.navList = res.resData.pageList ? res.resData.pageList : [];
        }
      });
    },
  },
  created() {
    if (this.parkServiceList.length) {
      this.serviceMsg = this.parkServiceList.find((val) => {
        return val.serviceFlag === 8;
      });
      this.getNavList();
    }
    const path = this.$route.path.split('/')[4] ? this.$route.path.split('/')[4] : 'cooperation';
    if (path === 'cooperation') {
      this.selectIndex = 8;
    } else {
      this.selectIndex = 15;
    }
  },
  computed: {
    ...mapGetters(['currentParkId', 'parkServiceList']),
  },
  watch: {
    selectIndex: {
      handler(newValue) {
        this.selectNav(newValue);
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.nav {
  margin-bottom: 26px;
  li {
    width: 284px;
    padding: 0 30px;
    height: 88px;
    float: left;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    &:nth-of-type(4n) {
      margin-right: 0;
    }
    &.select {
      border: 1px solid red;
    }
    h3 {
      font-size: 24px;
      font-weight: 600;
      width: 180px;
    }
    img {
      width: 44px;
      height: 44px;
      margin-right: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/bbs/Nav.vue